export * from './attachment.interface';
export * from './country.interface';
export * from './country-phone-number.interface';
export * from './detail-tab.interface';
export * from './group.interface';
export * from './permission.interface';
export * from './phone-number.interface';
export * from './query-search.interface';
export * from './selectable.interface';
export * from './sidebar.interface';
export * from './user.interface';
export * from './upload-info.interface';
